import React from "react"
import { ResponsiveBar } from "@nivo/bar"
import ChartCard from "./ChartCard"
import { PALETTE, NIVO_THEME } from "./palette"

const ManagersChart = ({ data }) => (
  <ChartCard
    icon     = "user-tie"
    title    = {I18n.t("chantiers_dashboard.charts.managers_breakdown")}
    subtitle = {I18n.t("chantiers_dashboard.charts.managers_breakdown_hint")}
    height   = {300}
    empty    = {data.length === 0 ? I18n.t("chantiers_dashboard.charts.empty") : null}
  >
    <ResponsiveBar
      data           = {data}
      keys           = {["value"]}
      indexBy        = "name"
      layout         = "horizontal"
      margin         = {{ top: 18, right: 28, bottom: 32, left: 150 }}
      padding        = {0.28}
      colors         = {[PALETTE.violet]}
      borderRadius   = {3}
      label          = {(d) => `${d.value}`}
      labelTextColor = "#fff"
      labelSkipWidth = {28}
      axisBottom     = {{ tickValues: 4 }}
      axisLeft       = {{ tickSize: 0, tickPadding: 10 }}
      gridXValues    = {4}
      tooltip        = {({ value, indexValue }) => (
        <div style={{ background: "#0f172a", color: "#fff", padding: "6px 10px", fontSize: 11, borderRadius: 6, boxShadow: "0 8px 20px rgba(15,23,42,0.25)" }}>
          <strong>{indexValue}</strong> · {value} {I18n.t("chantiers_dashboard.kpis.projects").toLowerCase()}
        </div>
      )}
      theme          = {NIVO_THEME}
    />
  </ChartCard>
)

export default ManagersChart
